/**
 * API Configuration
 * 
 * dev only:
 * - Uses REACT_APP_API_URL from .env.local for local emulator testing
 * - .env.local is gitignored and safe for local development
 * 
 * prod only:
 * - Preferred: let the app call the same origin with /api and use Firebase Hosting rewrites
 *   - Frontend: https://a11y-widget-com.web.app/
 *   - API:      https://a11y-widget-com.web.app/api (rewritten to the Cloud Function)
 * - Optional override: set REACT_APP_API_URL in your build environment
 *   - Example: REACT_APP_API_URL=https://a11y-widget-com.web.app/api
 */
const defaultApiUrl =
	process.env.NODE_ENV === 'production'
		// In production, use Firebase Hosting origin + /api so rewrites work correctly
		? 'https://a11y-widget-com.web.app/api'
		// In development (emulator), default to localhost:5000 where firebase emulators serve hosting
		: 'http://localhost:5000/api';

export const api = {
	// Prefer REACT_APP_API_URL if set; otherwise use environment-specific default
	url: process.env.REACT_APP_API_URL || defaultApiUrl,
	// user
	user: 'user',
	adminUsers: 'user/admin',
	// auth
	register: 'auth/register',
	login: 'auth/login',
	tokenLogin: 'auth/token-login',
	reset: 'auth/reset',
	verify: 'auth/verify',
	// resources
	resources: 'resources',
	newResource: 'resources/new',
	updateResource: 'resources/update',
	deleteResource: 'resources/delete',
	//widget
	widget: 'widget',
	widgetUpdate: 'widget/update',
	widgetDelete: 'widget/delete',
};

export const pages = {
	main: '/welcome',
	login: '/login',
	register: '/register',
	newsite: '/newsite',
	editsite: '/editsite/:id',
	profile: '/profile',
	reset: '/reset',
	verify: '/verify/:token',
	sites: '/',
	admin: '/admin',
};
